// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"2c84556f","183":"6dd57fe4","787":"00d3c982"}[chunkId] + ".chunk.js";
};